import { Container, Row, Col, Card, Badge } from "react-bootstrap";
import * as S from "./styled";

export default function CorrecaoResultadoUI({
  title,
  notaFinal,
  competencias, // { c1, c2, c3, c4, c5 }
  comentarios,  // { c1, c2, c3, c4, c5 }
  imageUrl,
  extraActions,
  onBack
}) {
  const getCompetenciaColor = (nota) => {
    if (nota >= 160) return "success";
    if (nota >= 120) return "warning";
    return "danger";
  };

  const formatarNota = (nota) => (nota ? nota.toString() : "0");

  const formatarComentario = (texto) => {
    if (!texto) return "Nenhum comentário específico";
    const secoes = String(texto).split("|").map((secao) => secao.trim()).filter(Boolean);

    return secoes.map((secao, index) => (
      <div key={index} style={{ marginBottom: "15px" }}>
        <div
          style={{
            backgroundColor: "#f8f9fa",
            padding: "10px",
            borderRadius: "5px",
            borderLeft: "4px solid #007bff",
          }}
        >
          {secao}
        </div>
      </div>
    ));
  };

  const compList = [
    { key: "c1", label: "Competência 1", nota: competencias?.c1 ?? 0, texto: comentarios?.c1 ?? "" },
    { key: "c2", label: "Competência 2", nota: competencias?.c2 ?? 0, texto: comentarios?.c2 ?? "" },
    { key: "c3", label: "Competência 3", nota: competencias?.c3 ?? 0, texto: comentarios?.c3 ?? "" },
    { key: "c4", label: "Competência 4", nota: competencias?.c4 ?? 0, texto: comentarios?.c4 ?? "" },
    { key: "c5", label: "Competência 5", nota: competencias?.c5 ?? 0, texto: comentarios?.c5 ?? "" },
  ];

  return (
    <S.MainWrapper>
      <Container>
        <Row>
          <Col sm={12}>
            <S.MainContent>
              <Row>
                <Col>
                  <S.Header>
                    <h2>{title}</h2>
                    <S.NotaFinal>
                      Nota Final: <span>{notaFinal}</span>
                    </S.NotaFinal>
                  </S.Header>
                </Col>
              </Row>

              <Row>
                <Col md={12}>
                  <Card className="mb-4">
                    <Card.Header>
                      <h5>Competências</h5>
                    </Card.Header>
                    <Card.Body>
                      {compList.map((c) => (
                        <S.CompetenciaItem key={c.key}>
                          <div className="d-flex justify-content-between align-items-center mb-2">
                            <span><strong>{c.label}:</strong></span>
                            <Badge variant={getCompetenciaColor(c.nota)}>
                              {formatarNota(c.nota)}/200
                            </Badge>
                          </div>
                          <S.ProgressBar>
                            <S.ProgressFill
                              width={(c.nota / 200) * 100}
                              color={getCompetenciaColor(c.nota)}
                            />
                          </S.ProgressBar>
                        </S.CompetenciaItem>
                      ))}
                    </Card.Body>
                  </Card>
                </Col>
              </Row>

              <Row>
                <Col md={12}>
                  <Card className="mb-4">
                    <Card.Header>
                      <h5>Comentários por Competência</h5>
                    </Card.Header>
                    <Card.Body>
                      {compList.map((c) => (
                        <S.ComentarioItem key={c.key}>
                          <strong>{c.label}:</strong>
                          <div>{formatarComentario(c.texto)}</div>
                        </S.ComentarioItem>
                      ))}
                    </Card.Body>
                  </Card>
                </Col>
              </Row>

              {imageUrl && (
                <Row>
                  <Col>
                    <Card>
                      <Card.Header>
                        <h5>Imagem da Redação</h5>
                      </Card.Header>
                      <Card.Body>
                        <img
                          src={imageUrl}
                          alt="Redação"
                          style={{ width: "100%", height: "auto" }}
                        />
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              )}

              <Row className="mt-4">
                <Col className="text-center">
                  <button className="btn btn-secondary mr-3" onClick={onBack}>
                    Voltar
                  </button>
                  {/*botão "Ir para Minhas redações" */}
                    {extraActions ? extraActions : null}
                </Col>
              </Row>
            </S.MainContent>
          </Col>
        </Row>
      </Container>
    </S.MainWrapper>
  );
}